import request from '../../config/axiosConfig';
import { GET_LIST_RECONCILIATION } from '../../constants/apiEndPoint';

export const getListReconciliationRequest = async (data) => {
  const result = await request({
    url: GET_LIST_RECONCILIATION,
    method: 'POST',
    data,
  });
  return result?.data.data;
};
